import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "center-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "center-main page-main"
  }, [_c('div', {
    staticClass: "center-level"
  }, [_c('div', {
    staticClass: "center-level__title"
  }, [_vm._v("LEVEL UP")]), _c('div', {
    staticClass: "center-progress-box"
  }, [_c('div', {
    staticClass: "center-progress"
  }, [_c('div', {
    ref: "progressRef",
    staticClass: "center-progres-body"
  }, [_c('div', {
    staticClass: "center-progress-main"
  }, [_c('div', {
    staticClass: "bar",
    style: {
      width: _vm.userInfo.coin / _vm.settingInfo.levelConfig.userLevels[_vm.userInfo.user_level == 0 ? 0 : _vm.userInfo.user_level >= 99 ? 99 : _vm.userInfo.user_level].exp * 100 >= 100 ? 100 : _vm.userInfo.coin / _vm.settingInfo.levelConfig.userLevels[_vm.userInfo.user_level == 0 ? 0 : _vm.userInfo.user_level >= 99 ? 99 : _vm.userInfo.user_level].exp * 100 + '%'
    }
  })]), _c('div', {
    staticClass: "center-progress-level"
  }, [_c('span', [_vm._v("Lv." + _vm._s(_vm.userInfo.user_level))]), _vm.userInfo.user_level + 1 < _vm.settingInfo.levelConfig.userLevels.length ? _c('span', [_vm._v("Lv." + _vm._s(_vm.userInfo.user_level + 1))]) : _vm._e()])])]), _c('div', {
    staticClass: "center-progress-text"
  }, [_c('div', {
    staticClass: "center-progress-text-main"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "center-progress-text__label"
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.coin))]), _vm._v("/ " + _vm._s(_vm.settingInfo.levelConfig.userLevels[_vm.userInfo.user_level == 0 ? 0 : _vm.userInfo.user_level >= 99 ? 99 : _vm.userInfo.user_level].exp) + " ")])])])]), _c('div', {
    staticClass: "center-level__info"
  }, [_vm._v("More FanPoints > Higher Level > Earn MEME tokens + VP star rewards")])]), _c('div', {
    staticClass: "vipinfo",
    on: {
      "click": () => _vm.$router.push(`/vip`)
    }
  }, [_c('div', {
    staticClass: "vipinfo-bg",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/vip-detail-bg.jpg`)}) center/100% 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "vipinfo-main"
  }, [_c('div', {
    staticClass: "vipinfo__level"
  }, [_vm._v(" VIP " + _vm._s(_vm.userInfo.vip_level) + " "), _c('div', {
    staticClass: "icon-quest"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-quest"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => _vm.popBenefitsShow = true).apply(null, arguments);
      }
    }
  })], 1)]), _c('div', {
    staticClass: "vipinfo-progress"
  }, [_c('div', {
    staticClass: "vipinfo-progress-bg",
    style: {
      '--w': '100%'
    }
  }, [_c('div', {
    staticClass: "bar"
  })]), _c('div', {
    staticClass: "vipinfo-progress-main",
    style: {
      '--w': _vm.userInfo.total_out_diamond / _vm.settingInfo.levelConfig.vipLevels[_vm.userInfo.vip_level == 0 ? 0 : _vm.userInfo.vip_level].exp * 100 + '%'
    }
  }, [_c('div', {
    staticClass: "bar"
  })])]), _c('div', {
    staticClass: "vipinfo__title"
  }, [_vm._v("You need to spend " + _vm._s(_vm.settingInfo.levelConfig.vipLevels[_vm.userInfo.vip_level == 0 ? 0 : _vm.userInfo.vip_level].exp - _vm.userInfo.total_out_diamond) + " diamonds to reach VIP " + _vm._s(_vm.userInfo.vip_level + 1))]), _vm._m(0), _vm.userCardInfo ? _c('div', {
    staticClass: "vipinfo-list"
  }, [_c('div', {
    staticClass: "vipinfo-item"
  }, [_c('div', {
    staticClass: "vipinfo-item-main",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-bitm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_vm._v("+" + _vm._s(_vm.userCardInfo.total_coin_addition ? _vm.fmt_pre(_vm.userCardInfo.total_coin_addition) : 0) + "%")]), _c('div', {
    staticClass: "vipinfo-item__title"
  }, [_vm._v("FanPoints Boost")])]), _c('div', {
    staticClass: "vipinfo-item"
  }, [_c('div', {
    staticClass: "vipinfo-item-main hour",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-bitm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_vm._v(_vm._s(_vm.userCardInfo.total_ai_chat ? _vm.fmt_pre(_vm.userCardInfo.total_ai_chat) : 0)), _c('span', [_vm._v("/Day")])]), _c('div', {
    staticClass: "vipinfo-item__title"
  }, [_vm._v("AI Chat")])])]) : _vm._e()])]), _c('div', {
    staticClass: "center-list"
  }, [_c('div', {
    staticClass: "center__titles"
  }, [_vm._v("My Information")]), _vm._l(_vm.userData, function (value, key) {
    return _c('div', {
      staticClass: "center-item",
      attrs: {
        "index": key
      },
      on: {
        "click": function ($event) {
          return _vm.onEditUserData(value, key);
        }
      }
    }, [_c('div', {
      staticClass: "center__head"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-${key}.png`),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "center-info"
    }, [_c('div', {
      staticClass: "center__title"
    }, [_vm._v(_vm._s(value.label))]), _vm.userInfo[`${key}_edit`] == 0 ? _c('div', {
      staticClass: "center__price"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-coin.png`),
        "alt": ""
      }
    }), _vm._v("+100")]) : _c('div', {
      staticClass: "center__edit"
    }, [key == 'birthday' ? [_vm._v(_vm._s(_vm.fmt_time(_vm.userInfo[key]).format("YYYY-MM-DD")))] : key == 'gender' ? [_vm._v(_vm._s(_vm.userInfo[key] == 0 ? "Male" : _vm.userInfo[key] == 1 ? "Female" : "Other"))] : [_vm._v(_vm._s(_vm.userInfo[key]))]], 2)]), _vm.userInfo[`${key}_edit`] == 1 ? _c('div', {
      staticClass: "center-status"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-ok"
      }
    })], 1) : _vm._e()]);
  })], 2)]), _c('m-menu'), _c('pop-prompt', {
    attrs: {
      "title": " ",
      "className": "popUserdata",
      "show": _vm.popPromptShow,
      "isDisableConfirm": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('isDisableConfirm') && _vm.popPromptInfo.isDisableConfirm,
      "isConfirmLoading": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('isConfirmLoading') && _vm.popPromptInfo.isConfirmLoading,
      "isBtnCancel": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('cancelText') && _vm.popPromptInfo.cancelText != null,
      "content": "html",
      "cancelText": _vm.popPromptInfo ? _vm.popPromptInfo.cancelText : ' ',
      "isBtnConfirm": _vm.popPromptInfo && _vm.popPromptInfo.confirmText,
      "confirmText": _vm.popPromptInfo ? _vm.popPromptInfo.confirmText : ' '
    },
    on: {
      "update:show": function ($event) {
        _vm.popPromptShow = $event;
      },
      "cancel": function ($event) {
        _vm.popPromptInfo && _vm.popPromptInfo.cancelText && _vm.popPromptInfo.hasOwnProperty('cancelFn') && _vm.popPromptInfo.cancelFn();
      },
      "confirm": function ($event) {
        _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('confirmFn') && _vm.popPromptInfo.confirmFn();
      }
    }
  }, [_c('div', {
    staticClass: "pop-userdata"
  }, [_vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('title') && _vm.popPromptInfo.title ? _c('div', {
    staticClass: "pop-userdata__title"
  }, [_vm._v(_vm._s(_vm.popPromptInfo.title))]) : _vm._e(), _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('reward') && _vm.popPromptInfo.reward ? _c('div', {
    staticClass: "pop-userdata__reward",
    domProps: {
      "innerHTML": _vm._s(_vm.popPromptInfo.reward)
    }
  }) : _vm._e(), _vm.selectKey ? _c('div', {
    staticClass: "pop-userdata-inputs"
  }, [_vm.selectKey.title == 'birthday' ? _c('div', {
    staticClass: "pop-userdata__date"
  }, [_c('div', {
    staticClass: "pop-userdata__datem"
  }, [!_vm.userdataInput ? _c('span', [_vm._v("Please select birthday")]) : [_vm._v(_vm._s(_vm.userdataInput))]], 2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userdataInput,
      expression: "userdataInput"
    }],
    attrs: {
      "type": "date",
      "min": "1900-01-01",
      "max": "2007-12-31"
    },
    domProps: {
      "value": _vm.userdataInput
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.userdataInput = $event.target.value;
      }, _vm.onInput],
      "click": _vm.onDateInputClick
    }
  })]) : _vm.selectKey.title == 'gender' ? _c('div', {
    staticClass: "pop-userdata__radio"
  }, [_c('div', {
    staticClass: "pop-userdata_radioitem",
    class: _vm.userdataInput == 0 && 'active',
    on: {
      "click": () => _vm.userdataInput = 0
    }
  }, [_vm._v("Male")]), _c('div', {
    staticClass: "pop-userdata_radioitem",
    class: _vm.userdataInput == 1 && 'active',
    on: {
      "click": () => _vm.userdataInput = 1
    }
  }, [_vm._v("Female")]), _c('div', {
    staticClass: "pop-userdata_radioitem",
    class: _vm.userdataInput == 2 && 'active',
    on: {
      "click": () => _vm.userdataInput = 2
    }
  }, [_vm._v("Other")])]) : _vm.selectKey.title == 'country' ? _c('div', {
    staticClass: "pop-userdata__input",
    on: {
      "click": _vm.showCountry
    }
  }, [_c('div', {
    staticClass: "pop-userdata__country"
  }, [!_vm.userdataInput ? _c('span', [_vm._v("Please select Country")]) : [_vm._v(_vm._s(_vm.userdataInput))]], 2)]) : _c('div', {
    staticClass: "pop-userdata__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userdataInput,
      expression: "userdataInput"
    }],
    attrs: {
      "type": "text",
      "placeholder": `Please enter ${_vm.selectKey?.title}`
    },
    domProps: {
      "value": _vm.userdataInput
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.userdataInput = $event.target.value;
      }, _vm.onInput]
    }
  })])]) : _vm._e(), _vm.selectKey && _vm.selectKey.isEdit == 1 ? _c('div', {
    staticClass: "pop-userdata-cost"
  }, [_vm._v("Cost: "), _c('img', {
    attrs: {
      "src": require(`@images/${_vm.aiSkin}/icon-diamond.png`),
      "alt": ""
    }
  }), _vm._v("1")]) : _vm._e()])]), _c('pop-prompt', {
    attrs: {
      "title": "Country",
      "show": _vm.popCountryShow,
      "content": "html",
      "isBtnConfirm": false,
      "isBtnCancel": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popCountryShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-country"
  }, [_c('div', {
    ref: "countryListRef",
    staticClass: "pop-country-list"
  }, _vm._l(_vm.countryList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-country-item",
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "pop-country__code"
    }, [_vm._v(_vm._s(index))]), _vm._l(item, function (itm, idx) {
      return _c('div', {
        key: idx,
        staticClass: "pop-country-itm",
        class: _vm.userdataInput == itm.name && 'active',
        on: {
          "click": function ($event) {
            return _vm.onSelectCountry(itm);
          }
        }
      }, [_vm._v(_vm._s(itm.name))]);
    })], 2);
  }), 0), _c('div', {
    staticClass: "pop-country-anchor"
  }, _vm._l(Array.from({
    length: 26
  }, (_, i) => String.fromCharCode(65 + i)), function (item, index) {
    return _c('span', {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.onCountryAnchor(item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0)])]), _c('pop-prompt', {
    attrs: {
      "location": "center",
      "className": "popBenefits",
      "title": "Benefits",
      "isShadowClick": true,
      "content": "html",
      "show": _vm.popBenefitsShow,
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popBenefitsShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-benefits"
  }, [_c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("Growth acceleration")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_vm._v("🎯 Mission FanPoints bonus🏃 Quickly reach level goals")])]), _c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("AI interaction privileges")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_vm._v("🤖 Voice AI cooldown time reduction")])]), _c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("Medal title")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_vm._v("🏅 Unlock subscription exclusive badges🎖 Enable exclusive titles (such as \"Star Messenger\")")])]), _c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("Airdrop reservation")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_vm._v("📬 Automatically enter the \"Future Airdrop Reservation List\"")])]), _c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("Exclusive missions")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_c('p', [_vm._v("🔓 Unlock subscription exclusive mission lines")]), _c('p', [_vm._v("🎁 Get more growth points/badges/lottery tickets🎲 Weekly lottery (such as autographed photos, etc.)")])])]), _c('div', {
    staticClass: "pop-benefits-more"
  }, [_vm._v("More fan benefits in the future")])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vipinfo__sub"
  }, [_vm._v(" The higher the VlP level, the more fan privileges you can"), _c('br'), _vm._v(" unlock in the future ")]);
}];
export { render, staticRenderFns };